import { prospectDemoReferenceExecution } from "@clickdialog/solution-contract";
import type { DemoManifest } from "../../types";

const EXECUTION = prospectDemoReferenceExecution(
  "gastronomy.reference-restaurant-v1",
);
if (!EXECUTION || EXECUTION.target.kind !== "platform-path") {
  throw new Error("gastronomy_reference_execution_invalid");
}

export const GASTRONOMY_REFERENCE_RESTAURANT_DEMO: DemoManifest = Object.freeze({
  id: "gastronomy.reference-restaurant-v1",
  name: "Casa Nativa — Restaurante de referencia",
  vertical: "Gastronomía",
  industryKey: "gastronomy",
  industryLabel: "Gastronomy",
  nicheKey: "restaurant",
  nicheLabel: "Restaurant",
  solutionKey: "restaurant-system",
  solutionLabel: "Restaurant System",
  demoType: "reference",
  maturity: "certified",
  runtimeStatus: EXECUTION.runtimeStatus,
  status: "reference",
  statusLabel: "Referencia V1",
  summary: "Implementación ficticia tratada como un cliente real: web pública, pedidos y operación conectados sobre el mismo estado aislado.",
  scopeLabel: "Referencia V1 · circuito funcional completo",
  capabilities: Object.freeze([
    "Web pública y menú",
    "Pedido end-to-end",
    "Cocina / KDS",
    "Inventario",
    "Cliente e historial",
    "Analytics derivados de operación real",
  ]),
  launch: Object.freeze({ kind: "reference-casa-nativa" }),
});
